export default "__VITE_ASSET__6e9674e6__"